import { LendPeak } from '../../LendPeak';
import { Amortization } from '../../Amortization';
import { LocalDate, ChronoUnit } from '@js-joda/core';
import { TermCalendars } from '../../TermCalendars';
import { Calendar, CalendarType } from '../../Calendar';
const today = LocalDate.now().minus(1, ChronoUnit.MONTHS).minus(20, ChronoUnit.DAYS);
export class DemoC3 {
    static LendPeakObject() {
        return new LendPeak({
            amortization: new Amortization({
                id: 'DEMO-C03',
                name: 'DEMO-C03',
                description: '20 days delinquent, no pays',
                startDate: today,
                originationFee: 600,
                loanAmount: 19_900,
                interestAccruesFromDayZero: true,
                annualInterestRate: 0.2399,
                term: 12,
                calendars: new TermCalendars({
                    primary: new Calendar(CalendarType.ACTUAL_365),
                }),
                defaultPreBillDaysConfiguration: 15,
            }),
        });
    }
    static ImportObject() {
        const lendPeak = DemoC3.LendPeakObject();
        return {
            loan: lendPeak.amortization,
            deposits: lendPeak.depositRecords,
        };
    }
}
